import { BooleanString } from './withdrawal';

export enum CouponType {
  FreeCoupon = '01', // 免息券
  DiscountCoupon = '02', // 利息折扣券
  ReduceInterestCoupon = '03', // 减息券
  CashCoupon = '04', // 现金回贈券
  ConcertCoupon = '05', // 音乐会兑换券
}

export enum redemptionStatusType {
  NotUsed = 'NOT_USED', // 未使用
  InUse = 'IN_USE', // 使用中
  Used = 'USED', // 已使用
  VerificationFailed = 'VERIFICATION_FAILED', // 核销失败
}

export enum expireFlagType {
  ExpiredSoon = 'F', // 即將过期
  Expired = 'Y', // 已过期
}

export type CouponData = {
  id?: string;
  value?: number; // 数值
  type?: CouponType | null; //
  validStartTime: string;
  validEndTime: string;
  couponTaskDto: CouponTaskAppDto | undefined;
  couponMetaDto: CouponMetaDto | undefined;
  assignProductList: string;
  redemptionStatus?: redemptionStatusType | undefined;
  isExpire?: string;
  isRecovery?: string;
  couponMetaI18nDto: CouponMetaI18nDto | null;
  isPreset?: BooleanString;
  expireFlag?: string; // 即将过期标识
  remainingValidDays?: number; // 剩余有效天数
  couponTypeDesc?: string; // 优惠券类型描述
  // 以下是音乐券专用
  exchangeTime?: string; // 兑换时间
  exchangeLocation?: string; // 兑换地点
};

//  ------------------------------------------ 分割线 ---------------------------------------------- //
// 上方的部分为前端使用到的数据，以下部分均为后端返回数据。
//  ------------------------------------------ 分割线 ---------------------------------------------- //

export type CouponIssueUserDto = {
  bizId?: number; // 命中业务主键
  bizType?: string; // 命中业务类型
  contractNo?: string; // 使用合约
  couponIssueNumber?: string; // 优惠券发放编号
  couponMetaDto?: CouponMetaDto; //
  couponMetaId?: number; // 优惠券模板ID
  couponStatus?: string; // 优惠券状态
  couponTaskDto?: CouponTaskAppDto; //
  createdTime?: string; // 发出时间
  distributeTaskId?: number; // 优惠券分发任务ID
  id?: string; // 优惠券绑定用户记录ID
  isExpire?: string; // 是否过期：Y/N
  isRecovery?: string; // 是否回收：Y/N
  issueStatus?: string; // 发放状态
  productCode?: string; // 产品
  redemptionStatus?: redemptionStatusType; // 核销状态
  redemptionUserId?: number; // 账户号码
  usedTime?: string; // 使用时间
  userId?: number; // 客户ID
  validEndTime?: string; // 优惠券有效日期到
  validStartTime?: string; // 优惠券有效日期从
  assignProductList?: string; // 优惠券适用于哪些产品
  isPreset?: BooleanString;
  expireFlag?: string; // 即将过期标识
  remainingValidDays?: number; // 剩余有效天数
  couponTypeDesc?: string; // 优惠券类型描述
  // 以下是音乐券专用
  exchangeTime?: string; // 兑换时间
  exchangeLocation?: string; // 兑换地点
};

export type CouponTaskAppDto = {
  appPushCn?: string; // appPush-中文
  appPushEn?: string; // appPush-英文
  approveId?: number; // 审批人
  approveName?: string; // 审批人-姓名
  approveStatus?: string; // 审批状态
  approveStatusDesc?: string; // 审批状态描述
  couponMetaId?: string; // 优惠券模版ID
  couponTermCn?: string; // 优惠券条款-中文
  couponTermEn?: string; // 优惠券条款-英文
  distributeTaskNumber?: string; // 优惠券分发任务编号
  distributeType?: string; // 发放途径
  distributeTypeDesc?: string; // 发放途径描述
  followTime?: string; // 跟进期限
  id?: string; // 优惠券分发任务ID
  maxNumPerUser?: number; // 单户总量
  maxUserNumber?: number; // 可发券总量
  objectVersionNumber?: number; // 版本号 乐观锁实现
  priority?: string; // 优先级
  requestId?: number; // 申请人
  requestName?: string; // 申请人-姓名
  smsCn?: string; // sms-中文
  smsEn?: string; // sms-英文
  taskEndTime?: string; // 任务有效日期到
  taskStartTime?: string; // 任务有效日期从
  taskStatus?: string; // 任务执行状态
  taskStatusDesc?: string; // 任务执行状态描述
  ticketId?: number; // 工单ID
  validDays?: number; // 优惠券有效期(天)(1-365)
  couponDistributeTaskI18nDto?: CouponDistributeTaskI18nDto; // 详情内容
  bannerUrl?: string; // 横幅图片
};

export type CouponDistributeTaskI18nDto = {
  appPush?: string; // app push
  couponTerm?: string; // 优惠券条款
  createBy?: string; //
  createdTime?: string; //
  distributeTaskId?: number; // 分发任务ID
  id?: string; // 优惠券分发任务多语言ID
  isDelete?: string; //
  language?: string; // 语言
  objectVersionNumber?: number; // 版本号 乐观锁实现
  sms?: string; // sms
  updateBy?: string; //
  updatedTime?: string; //
  // 以下是音乐券专用
  useInstructions?: string; // 使用说明
  otherCouponTerm?: string; // 其他条款
};

export type CouponMetaDto = {
  approveName?: string; // 审批人名称
  approveTime?: string; // 审批时间
  approverId?: number; // 审批人
  assignProductList?: string; // 适用产品
  couponContent?: string; // 优惠内容
  couponMetaName?: string; // 优惠券模版名称
  couponMetaNumber?: string; // 优惠券模版编号
  couponStatus?: string; // 优惠券状态
  couponType?: CouponType; // 优惠券类型
  distributeTaskCount?: number; // 所有任务数
  distributeTaskDoingCount?: number; // 进行中的任务数
  followTime?: string; // 跟进期限
  iconUrl?: string; // 优惠券图标
  id?: string; // 优惠券模版ID
  priority?: string; // 优先级
  requestId?: number; // 申请人
  requestName?: string; // 申请人名称
  requestTime?: string; // 申请时间
  ticketId?: number; // 工单ID
  validDays?: number; // 有效天数
  param1?: number; // 优惠券参数1
  param2?: number; // 优惠券参数2
  param3?: number; // 优惠券参数3
  couponMetaI18nDto?: CouponMetaI18nDto; // 国际化
};

export type CouponMetaI18nDto = {
  couponContent?: string; // 优惠内容(展示)
  couponMetaId?: number; // 优惠券模版编号
  couponMetaName?: string; // 优惠券模版名称
  createBy?: string; //
  createdTime?: string; //
  id?: string; // 优惠券模版ID
  isDelete?: string; //
  language?: string; // 语言
  objectVersionNumber?: number; // 版本号 乐观锁实现
  updateBy?: string; //
  updatedTime?: string; //
  couponRemake?: string; // 列表里显示优惠券适用范围描述
};

export type PreviewCouponData = {
  couponTaskDto: CouponTaskAppDto | undefined;
  couponMetaDto: CouponMetaDto | undefined;
};
